/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest = {
  nodeProviderId: string;
};

/** @internal */
export const GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$inboundSchema:
  z.ZodType<
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    node_provider_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "node_provider_id": "nodeProviderId",
    });
  });

/** @internal */
export type GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$Outbound = {
  node_provider_id: string;
};

/** @internal */
export const GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$outboundSchema:
  z.ZodType<
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest
  > = z.object({
    nodeProviderId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      nodeProviderId: "node_provider_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$Outbound;
}

export function getApiV3ImagesNodeProvidersNodeProviderIdPngRequestToJSON(
  getApiV3ImagesNodeProvidersNodeProviderIdPngRequest:
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$outboundSchema.parse(
      getApiV3ImagesNodeProvidersNodeProviderIdPngRequest,
    ),
  );
}

export function getApiV3ImagesNodeProvidersNodeProviderIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesNodeProvidersNodeProviderIdPngRequest' from JSON`,
  );
}
